const searchConfig = {
	minCharactersBeforeSearch: 3,
	debounceSearchMs: 300,
	timeoutBeforeNoResultsDisplayMs: 700,
}

export default searchConfig
